
  import ScreenSize from '@/mixins/ScreenSize';
  import EventBus from '@/events/EventBus';
  import Events from '@/events/Events';
  import {prepareApiUrl} from '@/helper/UrlHelper';
  import VueCropper from 'vue-cropperjs';
  import 'cropperjs/dist/cropper.css';
  import DialogsBaseSection from '@/components/sections/DialogsBaseSection.vue';

  export default {
    name: 'ProfileImageUpload',
    components: {DialogsBaseSection, VueCropper},
    mixins: [ScreenSize],
    props: {
      image: {
        type: Object,
        required: false,
        default: () => ({}),
      },
      route: {
        type: String,
        required: true,
      },
      placeholder: {
        type: String,
        required: false,
        default: null,
      },
    },
    data() {
      return {
        dialog: false,
        inputFile: undefined,
        errors: [],
        scaleX: 1,
        scaleY: 1,
        section: {},
      };
    },
    async fetch() {
      this.section = await this.$cachedStrapi
        .find('profile-image-upload-dialog')
        .catch((e) => {
          if (e.statusCode !== 404) {
            throw e;
          }
        });
    },
    methods: {
      onFileSelect(file) {
        this.errors = [];
        if (!file) {
          return;
        }
        if (!['image/png', 'image/jpeg'].includes(file.type)) {
          this.errors = [this.$t('validation.mime_type.image')];
          return;
        }

        if (typeof FileReader === 'function') {
          this.dialog = true;
          const reader = new FileReader();
          reader.onload = (event) => {
            this.$refs.cropper.replace(event.target.result);
          };
          reader.readAsDataURL(file);
        } else {
          alert('Sorry, FileReader API not supported');
        }
      },
      async saveImage() {
        const name = this.inputFile.name;
        const type = this.inputFile.type;
        const maxPixels = 10 * 1000000; // 10 MegaPixels

        if (this.image) {
          await this.deleteImage();
        }

        let croppedCanvas = this.$refs.cropper.getCroppedCanvas();

        // Get the width and height of the cropped image in pixels
        const croppedImageWidth = croppedCanvas.width;
        const croppedImageHeight = croppedCanvas.height;
        const totalPixels = croppedImageWidth * croppedImageHeight;

        if (totalPixels > maxPixels) {
          // Calculate the scale factor to resize the image while preserving its aspect ratio
          const scaleFactor = Math.sqrt(maxPixels / totalPixels);

          // Calculate the new dimensions for resizing
          const newWidth = Math.round(croppedImageWidth * scaleFactor);
          const newHeight = Math.round(croppedImageHeight * scaleFactor);

          // Create a new canvas with the resized dimensions
          const resizedCanvas = document.createElement('canvas');
          resizedCanvas.width = newWidth;
          resizedCanvas.height = newHeight;

          // Draw the cropped canvas onto the new resized canvas
          const ctx = resizedCanvas.getContext('2d');
          ctx.drawImage(croppedCanvas, 0, 0, newWidth, newHeight);

          // Set the resized canvas as the new cropped canvas
          croppedCanvas = resizedCanvas;

          //Show notification that image is resized
          this.$notifications.showNotification({
            message: this.$t('profile_image.action_resize'),
            color: 'warning',
            timeout: 2000,
          });
        }

        croppedCanvas.toBlob(
          (blob) => {
            const formData = new FormData();
            formData.append('file', blob, name);
            this.$axios
              .post(
                prepareApiUrl(this.route, {
                  routeParameters: {
                    id: this.$auth.user.candidateProfile.id,
                  },
                }),
                formData
              )
              .then(() => {
                this.$auth.fetchUser().then(() => {
                  this.$store
                    .dispatch(
                      'profileCompleteness/calculateProfileCompleteness'
                    )
                    .then(() => {
                      EventBus.$emit('profile-image-upload-save');
                    });
                });

                this.$notifications.showNotification({
                  message: 'Bild wurde hochgeladen',
                  color: 'success',
                  timeout: 5000,
                });

                this.$emitWithClientData(Events.ProfileImageChanged);
              })
              .catch((error) => {
                // eslint-disable-next-line no-console
                console.log('error', error);

                this.$notifications.showNotification({
                  message: 'Fehler bei Upload des Bildes',
                  color: 'error',
                  timeout: 5000,
                });
              });
          },
          type,
          0.9
        );
        this.closeDialog();
      },
      async deleteImage() {
        await this.$axios.delete(
          prepareApiUrl(process.env.NUXT_ENV_API_PROFILE_IMAGES_ENDPOINT, {
            routeParameters: {id: this.image.id},
          })
        );
      },
      flipX() {
        this.scaleX = -this.scaleX;
        this.$refs.cropper.scaleX(this.scaleX);
      },
      flipY() {
        this.scaleY = -this.scaleY;
        this.$refs.cropper.scaleY(this.scaleY);
      },
      rotate(deg) {
        this.$refs.cropper.rotate(deg);
      },
      closeDialog() {
        this.dialog = false;
        this.inputFile = undefined;
        this.scaleX = 1;
        this.scaleY = 1;
      },
    },
  };
